class @StylesheetForm

  @setup: ->
    $(".form-section-container.form_style").each -> 
      $section = $(@)
      $mode    = $("select.stylesheet_mode", $section)
      $cssText = $("textarea.stylesheet_css", $section)
      $cssLine = $cssText.closest("li.form-field")

      adjustVisibility = ->
        mode = $mode.val()
        if mode == "0"
          $cssLine.show()
          $cssText.removeAttr("disabled")
        else
          $cssLine.hide()
          $cssText.attr("disabled", "disabled")

      adjustVisibility()
      $mode.change(adjustVisibility)
